// removed by extract-text-webpack-plugin
module.exports = {"LibraryPackHeader":"_2Pfqw71DAekSNN-f3KZrj","LibraryPackHeader__background":"Hi3IF2RFUZnkLlZS0nG6w","LibraryPackHeader__wrap":"_3grM7Psh374QUbdUinItBf","LibraryPackHeader__guts":"_3YzEXUq8AsnSUDuNKNFE9O","LibraryPackHeader__comingSoon":"_2_LpmH9ZRZeD3KxN0q78UA","LibraryPackHeader__title":"_1NgE-527f02-1YiAcLNhBp","LibraryPackHeader__description":"uN4gBgmarhuAtuj0j7FYj","LibraryPackHeader__descriptionLink":"lXoYtWaZ40JyLIOGq4ztO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryPackHeader/LibraryPackHeader.scss
// module id = 2363
// module chunks = 0